(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cvt-moonbox-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cvt-moonbox-options')) {
    customElements.define('cvt-moonbox-options', class extends HTMLElement {
      connectedCallback() {
        this.vehicle = this.querySelector('[data-moon-vehicle]');
        this.molle = this.querySelector('[data-moon-molle]');
        this.summary = this.querySelector('[data-moon-summary]');
        this.productInfo = this.closest('product-info');
        if (!this.vehicle || !this.molle || !this.productInfo) return;
        this.changeHandler = () => this.selectNative();
        this.addEventListener('change', this.changeHandler);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.productInfo, {childList: true, subtree: true});
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('change', this.changeHandler);
      }
      parse(value) {
        const parts = value.split(' · ');
        const suffix = parts.slice(1).join(' · ');
        return {vehicle: parts[0], system: /molle light/i.test(suffix) ? 'light' : /molle/i.test(suffix) ? 'molle' : 'standard'};
      }
      fill(select, values, selected) {
        select.replaceChildren(...values.map(({value, label}) => new Option(label, value, false, value === selected)));
      }
      sync() {
        const picker = this.productInfo.querySelector('variant-selects');
        if (!picker || picker === this.picker) return;
        const nativeGroup = picker.querySelector('.product-form__input');
        if (!nativeGroup) return;
        const inputs = [...nativeGroup.querySelectorAll('input[type="radio"], option')];
        if (!inputs.length) return;
        this.picker = picker;
        this.entries = inputs.map(input => ({input, ...this.parse(input.value)}));
        const selected = this.entries.find(({input}) => input.checked || input.selected) || this.entries[0];
        this.fill(this.vehicle, [...new Set(this.entries.map(e => e.vehicle))].map(value => ({value, label: value})), selected.vehicle);
        this.fillSystems(selected.system);
        nativeGroup.classList.add('cvt-moonbox-native');
        this.hidden = false;
      }
      fillSystems(selected) {
        const values = [...new Set(this.entries.filter(e => e.vehicle === this.vehicle.value).map(e => e.system))];
        const order = ['standard', 'light', 'molle'].filter(v => values.includes(v));
        this.fill(this.molle, order.map(value => ({value, label: this.dataset[value + 'Label']})), values.includes(selected) ? selected : order[0]);
        this.molle.closest('.product-form__input').hidden = order.length < 2;
        this.summary.textContent = this.vehicle.value;
      }
      selectNative() {
        this.fillSystems(this.molle.value);
        const entry = this.entries.find(e => e.vehicle === this.vehicle.value && e.system === this.molle.value);
        if (!entry) return;
        const input = entry.input;
        if (input.tagName === 'OPTION') {
          input.parentElement.value = input.value;
          input.parentElement.dispatchEvent(new Event('change', {bubbles: true}));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
